import { render, staticRenderFns } from "./index.vue?vue&type=template&id=24439ff6&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24439ff6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\华水\\hsmanagementsystem\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('24439ff6')) {
      api.createRecord('24439ff6', component.options)
    } else {
      api.reload('24439ff6', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=24439ff6&scoped=true", function () {
      api.rerender('24439ff6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/historicalSupplement/index.vue"
export default component.exports